/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-gauge': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<defs><path pid="0" d="M7 0a7 7 0 1 1-7 6.95v-.013A7 7 0 0 1 7 0zm.45 1.017V1.7a.45.45 0 0 1-.893.081l-.007-.08v-.685A6.001 6.001 0 0 0 1.02 6.5h.681a.45.45 0 0 1 .081.893l-.08.007h-.689a6 6 0 0 0 11.974 0h-.688a.45.45 0 0 1-.081-.893l.08-.007h.681a6.001 6.001 0 0 0-5.53-5.483zm3.337 2.28a.45.45 0 0 1 .052.575l-.052.062-2.092 2.093c.246.43.327.955.186 1.473a1.962 1.962 0 0 1-2.39 1.385A1.937 1.937 0 0 1 5.12 6.5a1.962 1.962 0 0 1 2.96-1.13l2.071-2.072a.45.45 0 0 1 .637 0zm-3.62 2.665a1.064 1.064 0 0 0-1.18.774c-.152.56.177 1.132.734 1.279a1.062 1.062 0 0 0 1.292-.75 1.037 1.037 0 0 0-.734-1.28z" id="svgicon-icon-gauge-a"/></defs><use _fill="#006265" fill-rule="nonzero" xlink:href="#svgicon-icon-gauge-a"/>'
  }
})
